export const PROFILE = {
  "contact": {
    "twitter": "https://twitter.com/bytebeacon",
    "linkedin": "https://www.linkedin.com/company/bytebeacon",
    "github": "https://github.com/bytebeacon",
    "facebook": "https://www.facebook.com/ByteBeacon-109146270805201",
// // "https://www.quora.com/profile/"+contact.quora
// // "https://www.instagram.com/"+contact.instagram
// // "https://hub.docker.com/r/"+contact.docker
  }
};



export const SITE = {
  url: "https://passivecompound.bytebeacon.com",
  title: "PassiveCompound | Financial freedom  at your fingertips!",
  description: "Start investmenting, even in small amounts, and let the power of compounding show its magic.",
  logo: "https://sn126.com/logo.png",
}



export const SECTOR_COLOR = {
  "Technology": '#8dd3c7',
  "Consumer Defensive": '#ffed6f',
  "Communication Services": '#bebada',
  "Healthcare": '#fb8072',
  "Real Estate": '#80b1d3',
  "Financial Services": '#fdb462',
  "Industrials": '#b3de69',
  'Consumer Cyclical': '#fccde5', 
  'Energy': '#d9d9d9', 
  'Basic Materials': '#bc80bd', 
  'Utilities': '#ccebc5', 
  '': '#efffb3',
  undefined: '#efffb3',
}
